(function () {
  if (!/^fr(?:-|$)/i.test(document.documentElement.lang)) return;

  function updateBanner(banner) {
    const paragraph = banner.querySelector('.shopify-pc__banner__body p');
    const link = banner.querySelector('#shopify-pc__banner__body-policy-link');
    if (!paragraph || !link || paragraph.dataset.anomCopy === '20260907') return;

    paragraph.dataset.anomCopy = '20260907';
    link.textContent = 'En savoir plus';
    paragraph.replaceChildren(
      document.createTextNode('Avec votre accord, nous et nos partenaires, dont Shopify, utilisons des cookies pour personnaliser votre exp\u00e9rience, mesurer l\u2019audience et adapter les publicit\u00e9s. Votre choix reste modifiable \u00e0 tout moment. '),
      link
    );
  }

  function inspect(node) {
    if (node.nodeType !== Node.ELEMENT_NODE) return;
    if (node.id === 'shopify-pc__banner') updateBanner(node);
    else node.querySelectorAll('#shopify-pc__banner').forEach(updateBanner);
  }

  // Shopify inserts and recreates its banner asynchronously; leave its consent controls intact.
  function start() {
    inspect(document.body);
    new MutationObserver(function (records) {
      records.forEach(function (record) { record.addedNodes.forEach(inspect); });
    }).observe(document.body, { childList: true, subtree: true });
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', start, { once: true });
  else start();
})();
